import React from 'react';
import './Button.css';

interface ButtonProps {
  onClick?: () => void;
  label: string;
  className?: string;
  disabled?: boolean;
  color?: 'primary' | 'gray' | 'danger';
  type?: 'button' | 'submit' | 'reset';
  size?: 'small' | 'medium' | 'large';
  icon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  label,
  className = '',
  disabled = false,
  color = 'primary',
  type = 'button',
  size = 'medium',
  icon
}) => {
  const buttonClass = `app-button ${color} ${size} ${className} ${disabled ? 'disabled' : ''}`;
  
  return (
    <button
      type={type}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="button-icon">{icon}</span>}
      {label}
    </button>
  );
};

export default Button; 